module.exports = __webpack_public_path__ + "media/images/workplace/SVG/cw-loader-15da4c852481ad3e18981dab427c982e.svg";